document.addEventListener('DOMContentLoaded', () => {
  initTheDifferenceSections();
});

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector?.('.the-difference') || event.target.closest?.('.the-difference');
  if (section) initTheDifferenceSection(section);
});

function initTheDifferenceSections() {
  document.querySelectorAll('.the-difference').forEach(initTheDifferenceSection);
}

function initTheDifferenceSection(container) {
  if (!container || container.dataset.differenceReady === 'true') return;
  container.dataset.differenceReady = 'true';

  const intervalTime = parseInt(container.dataset.autoplayInterval, 10) || 5000;
  const navButtons = container.querySelectorAll('.the-difference__tab');
  const contentPanes = container.querySelectorAll('.the-difference__pane');
  const imagePanes = container.querySelectorAll('.the-difference__media');

  let currentIndex = 0;
  let autoplayTimer = null;
  let isPaused = false;
  const totalTabs = navButtons.length;

  if (totalTabs === 0) return;

  const switchTab = (index) => {
    navButtons.forEach((btn) => {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-selected', 'false');
    });
    contentPanes.forEach((pane) => pane.classList.remove('is-active'));
    imagePanes.forEach((pane) => pane.classList.remove('is-active'));

    if (navButtons[index]) {
      navButtons[index].classList.add('is-active');
      navButtons[index].setAttribute('aria-selected', 'true');
    }
    if (contentPanes[index]) contentPanes[index].classList.add('is-active');
    if (imagePanes[index]) imagePanes[index].classList.add('is-active');

    currentIndex = index;
  };

  const startAutoplay = () => {
    if (autoplayTimer) clearInterval(autoplayTimer);
    autoplayTimer = setInterval(() => {
      if (!isPaused) {
        switchTab((currentIndex + 1) % totalTabs);
      }
    }, intervalTime);
  };

  const stopAutoplay = () => {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  };

  navButtons.forEach((btn, index) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      switchTab(index);
      stopAutoplay();
      startAutoplay();
    });
  });

  container.addEventListener('mouseenter', () => {
    isPaused = true;
  });

  container.addEventListener('mouseleave', () => {
    isPaused = false;
  });

  container.addEventListener('touchstart', () => {
    isPaused = true;
  }, { passive: true });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        startAutoplay();
      } else {
        stopAutoplay();
      }
    });
  }, { threshold: 0.3 });

  observer.observe(container);
}
